__turbopack_context__.v({
  "accordionSlideOverwrite": "organization-hosted-events-module-scss-module__cwAsla__accordionSlideOverwrite",
  "container": "organization-hosted-events-module-scss-module__cwAsla__container",
  "fadeIn": "organization-hosted-events-module-scss-module__cwAsla__fadeIn",
  "fadeOut": "organization-hosted-events-module-scss-module__cwAsla__fadeOut",
  "grid": "organization-hosted-events-module-scss-module__cwAsla__grid",
  "image": "organization-hosted-events-module-scss-module__cwAsla__image",
  "message": "organization-hosted-events-module-scss-module__cwAsla__message",
  "scaleIn": "organization-hosted-events-module-scss-module__cwAsla__scaleIn",
  "scaleOut": "organization-hosted-events-module-scss-module__cwAsla__scaleOut",
  "title": "organization-hosted-events-module-scss-module__cwAsla__title",
  "zoomIn": "organization-hosted-events-module-scss-module__cwAsla__zoomIn",
  "zoomOut": "organization-hosted-events-module-scss-module__cwAsla__zoomOut",
});
